import React from 'react';

import { Container } from 'components';
import TutorialLink from 'widgets/@HowItWorks/TutorialLink';

import * as styles from './styles.module.scss';

function UserTutorials() {
  const tutorials = [
    {
      label: 'For teachers',
      link: 'https://help.codechum.com/teachers',
    },
    {
      label: 'For students',
      link: 'https://help.codechum.com/students',
    },
  ];

  return (
    <section className={styles.section}>
      <Container>
        <div className={styles.container}>
          {tutorials.map((tutorial) => (
            <TutorialLink key={tutorial.label} {...tutorial} />
          ))}
        </div>
      </Container>
    </section>
  );
}

export default UserTutorials;
